import React from 'react';
import { useMsal } from '@azure/msal-react';
import { isE2EMockAuth, getE2EMockRole } from '../../utils/e2eMockAuth';

type RequireRoleProps = {
  role: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

const RequireRole: React.FC<RequireRoleProps> = ({ role, children, fallback }) => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
  const userRoles = isE2EMockAuth()
    ? (getE2EMockRole() ? [getE2EMockRole()] : [])
    : (account?.idTokenClaims as unknown as { roles?: string[] })?.roles || [];

  const requiredRoles = Array.isArray(role) ? role : [role];
  const hasRole = Array.isArray(userRoles) && requiredRoles.some(r => userRoles.includes(r));

  if (!hasRole) {
    return (
      <div className="p-6">
        {fallback ?? <div>You do not have access to this page.</div>}
      </div>
    );
  }

  return <>{children}</>;
};

export default RequireRole;


